import { render, staticRenderFns } from "./view.vue?vue&type=template&id=696349d8&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"
import style0 from "./view.vue?vue&type=style&index=0&id=696349d8&prod&lang=scss&scoped=true"
import style1 from "./view.vue?vue&type=style&index=1&id=696349d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696349d8",
  null
  
)

export default component.exports